var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-toast",class:[_vm.type]},[_c('i'),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"close",on:{"click":_vm.close}})])}
var staticRenderFns = []

export { render, staticRenderFns }